import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { createIndexedDBStorage } from "../lib/profileStorage";

interface Profile {
  name: string;
  avatar?: string;
  theme: "dark" | "darker";
  accentColor: string;
  showListeningStatus: boolean;
  shareProfile: boolean;
  emailNotifications: boolean;
  pushNotifications: boolean;
  email?: string;
  memberSince?: string;
  developerMode: boolean;
  developerModeTaps: number;
  wasDevBefore: boolean;
}

interface ProfileState {
  profile: Profile;
  updateProfile: (updates: Partial<Profile>) => void;
  resetProfile: () => void;
}

const defaultProfile: Profile = {
  name: "friend",
  theme: "dark",
  accentColor: "#22c55e",
  showListeningStatus: true,
  shareProfile: false,
  emailNotifications: true,
  pushNotifications: true,
  developerMode: false,
  developerModeTaps: 0,
  wasDevBefore: false,
};

export const useProfileStore = create<ProfileState>()(
  persist(
    (set) => ({
      profile: defaultProfile,
      updateProfile: (updates) =>
        set((state) => ({
          profile: { ...state.profile, ...updates },
        })),
      resetProfile: () => set({ profile: defaultProfile }),
    }),
    {
      name: "profile-storage",
      storage: createJSONStorage(() => createIndexedDBStorage()),
    }
  )
);
